import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { partnersCopy } from "../i18n";
import { ArrowLeft, Zap, Percent, LayoutDashboard, PiggyBank } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

const ICONS = [Zap, Percent, LayoutDashboard, PiggyBank];

export default function PartnersLanding() {
  const { lang } = useLang();
  const p = partnersCopy[lang] || partnersCopy.es;
  return (
    <div className="min-h-screen bg-topacio-sand" data-testid="partners-page">
      <header className="bg-white border-b-2 border-topacio-ink sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" data-testid="partners-home-link" className="flex items-center gap-3">
            <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio" className="h-12 w-auto rounded-md border-2 border-topacio-ink shadow-[3px_3px_0_0_#111]" />
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/login" data-testid="partners-login-link"
              className="text-xs font-extrabold uppercase tracking-wider text-topacio-faded hover:text-topacio-ink transition-colors">
              {p.login}
            </Link>
            <Link to="/" className="btn-secondary !px-4 !py-2 !text-xs">
              <ArrowLeft className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </header>

      <section className="max-w-7xl mx-auto px-6 pt-20 pb-16">
        <p className="eyebrow mb-4">{p.eyebrow}</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-topacio-ink max-w-3xl leading-[1.1]">
          {p.title}
        </h1>
        <p className="mt-6 text-lg text-topacio-faded max-w-2xl">{p.sub}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <a href="mailto:rent@rentamotenerife.es?subject=Colaborador%20Rent%20a%20Moto%20Topacio"
            data-testid="partners-cta-btn" className="btn-primary">{p.cta}</a>
        </div>
        <p className="mt-4 text-sm text-topacio-faded">{p.ctaSub}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {p.benefits.map((b, i) => {
            const Icon = ICONS[i];
            return (
              <div key={i} data-testid={`partner-benefit-${i}`}
                className="card-brutal p-8 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#111] transition-[transform,box-shadow]">
                <div className="w-12 h-12 bg-brand border-2 border-topacio-ink rounded-lg flex items-center justify-center shadow-[3px_3px_0_0_#111]">
                  <Icon className="w-6 h-6 text-topacio-ink" strokeWidth={2.2} />
                </div>
                <h3 className="font-display text-base font-bold text-topacio-ink mt-5">{b.t}</h3>
                <p className="text-sm text-topacio-faded mt-2 leading-relaxed">{b.d}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="border-t-2 border-topacio-ink bg-white">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <h2 className="font-display text-2xl sm:text-3xl tracking-tight font-bold text-topacio-ink mb-10">{p.how}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {p.steps.map((s, i) => (
              <div key={i} data-testid={`partner-step-${i}`} className="card-brutal p-8 bg-topacio-sand">
                <h3 className="font-display text-lg font-bold text-topacio-red">{s.t}</h3>
                <p className="text-sm text-topacio-faded mt-3 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <SiempriaCredit />
    </div>
  );
}
